import { Title2 } from "../../text";
import styled from "styled-components";

const StaticContentTopicSubtitle = styled(Title2)`
  font-weight: 500;
`;

export default StaticContentTopicSubtitle;
